// Shared document-type definitions — bilingual labels, icons, colours, account role.
// Import this wherever DOC_TYPES is needed.

export const DOC_TYPE_MAP = {
  100: {
    code: 100,
    label:    'فاتورة شراء / Purchase',
    labelAr:  'فاتورة شراء',
    labelEn:  'Purchase',
    icon:     '📦',
    desc:     'شراء بضاعة من مورد',
    descEn:   'Buy goods from a supplier',
    accountRole: 'supplier',          // filter accounts to this role
    bg: '#eff6ff', color: '#1e40af',
  },
  120: {
    code: 120,
    label:    'مرتجع شراء / Purchase Return',
    labelAr:  'مرتجع شراء',
    labelEn:  'Purchase Return',
    icon:     '↩️',
    desc:     'إرجاع بضاعة إلى مورد',
    descEn:   'Return goods to a supplier',
    accountRole: 'supplier',
    bg: '#f0fdf4', color: '#166534',
  },
  200: {
    code: 200,
    label:    'فاتورة بيع / Sales Invoice',
    labelAr:  'فاتورة بيع',
    labelEn:  'Sales Invoice',
    icon:     '🧾',
    desc:     'بيع لعميل أو حساب',
    descEn:   'Sell to a customer or account',
    accountRole: 'customer',
    bg: '#f0fdf4', color: '#166534',
  },
  220: {
    code: 220,
    label:    'مرتجع بيع / Sales Return',
    labelAr:  'مرتجع بيع',
    labelEn:  'Sales Return',
    icon:     '↩️',
    desc:     'استرجاع بضاعة من عميل',
    descEn:   'Accept returned goods from a customer',
    accountRole: 'customer',
    bg: '#fff7ed', color: '#9a3412',
  },
  230: {
    code: 230,
    label:    'عرض سعر / Quote',
    labelAr:  'عرض سعر',
    labelEn:  'Quote',
    icon:     '📋',
    desc:     'عرض سعر لعميل (غير مؤثر على المخزون)',
    descEn:   'Price quote for a customer (no stock effect)',
    accountRole: 'customer',
    bg: '#f5f3ff', color: '#5b21b6',
  },
  300: {
    code: 300,
    label:    'جرد مخزون / Stock Count',
    labelAr:  'جرد مخزون',
    labelEn:  'Stock Count',
    icon:     '📊',
    desc:     'تسوية المخزون الفعلي',
    descEn:   'Adjust stock to physical count',
    accountRole: null,                // no account needed
    bg: '#f0f9ff', color: '#075985',
  },
  400: {
    code: 400,
    label:    'تالف / Loss',
    labelAr:  'تالف',
    labelEn:  'Loss',
    icon:     '🗑️',
    desc:     'بضاعة تالفة أو مفقودة',
    descEn:   'Damaged or missing goods',
    accountRole: null,
    bg: '#fef2f2', color: '#991b1b',
  },
};

// Simple label lookup used wherever the old DOC_TYPES object was used
export const DOC_TYPES = Object.fromEntries(
  Object.entries(DOC_TYPE_MAP).map(([k, v]) => [k, v.label])
);

// Groups for the type-picker modal
export const DOC_TYPE_GROUPS = [
  {
    group: 'شراء / Purchasing',
    types: [100, 120],
  },
  {
    group: 'بيع / Sales',
    types: [200, 220, 230],
  },
  {
    group: 'مخزون / Inventory',
    types: [300, 400],
  },
];
